import React, { Fragment, useState } from 'react'
import { Row, Col, Nav, NavLink, Card, CardBody, Button, Media, Table } from 'reactstrap';
import 'animate.css';
import './styleCash.css';
import { useCash } from '../../hooks/cash/useCash';
import { ModalPreviewTicket } from './ModalPreviewTicket';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';
import { FaFilePdf } from 'react-icons/fa';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Avatar } from 'primereact/avatar';
import mujerImage from '../../assets/images/user/mujer.png';
import { InputText } from "primereact/inputtext";
import { Dialog } from 'primereact/dialog';
import { ConfigServer } from '../../data/config'
import { cedimi } from '../../constant/globalConstantsTypeClients';
import { CustomAlertDialogGlobal } from '../alertDialog/CustomAlertDialogGlobal';
import { ToastAletGlobal } from '../alertDialog/ToastAletGlobal';






export const IndexCash = () => {

    let branchs = localStorage.getItem('branchName');

    const {
        //*CONFIGURATION CASH
        formCash, capture_amount, handleInputChangeCash,

        //*INDICATORS
        cancell, discountT, comments, saveCreate, formatter, totalCancell, totalPatients,

        //*HISTORIC
        dataHistoric, dateInit, dateEnd, changeDate, handleHistoric, typeAmoun, amountfin,

        //*FINAL REPORT
        dataDevolution,

        //*FINAL REPORT TYPE COMPANY
        number_format, sumPayMethods,

        //*PRINT TICKETS
        modalPrint, toggleModalPrint, handleViewTickets, printTicket, loadingPrint, loadingCreate, downloadExcel, _type_client,

        //* CASH and CREDIT
        downloadExcelCredits, downloadExcelOthers, dataUserReport, globalFilter, setGlobalFilter,
        _commercialLine, _nameUser, _branchName, loadingReport, getBadgePatient, getBadgeStatus, customBody,
        visibleTicket, showModalTicket, hideModalTicket,
        showAlert, cancelTabChange, showAlert2, cancelTabChange2,

        showToast, toastType, toastTitle, toastMessage, closeToastAlert

    } = useCash();


    let wilso = amountfin[0]
    let _arrayNew = ""
    let _total = ""

    if (_type_client === "https://insan.helen-sw.com1" && amountfin.length > 0) {
        _arrayNew = amountfin[0]
        _total = _arrayNew["EFECTIVO"]?.Amount
    }

    const totalCash = Number(wilso?.["EFECTIVO"]?.Amount ?? 0);

    const footerContent = (
        <div
            style={{
                background: "linear-gradient(135deg,#002940,#1d5b83)",
                margin: "-1rem",
                padding: "15px 22px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottomLeftRadius: "8px",
                borderBottomRightRadius: "8px"
            }}
        >
            <div style={{ color: "#fff" }}>
                <div
                    style={{
                        fontWeight: "700",
                        fontSize: "15px"
                    }}
                >
                    Efectivo a entregar
                </div>

                <div
                    style={{
                        fontSize: "12px",
                        opacity: ".8"
                    }}
                >
                    Monto registrado del efectivo
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "25px"
                }}
            >
                <span
                    style={{
                        color: "#fff",
                        fontSize: "28px",
                        fontWeight: "700"
                    }}
                >
                    {formatter.format(totalCash)}
                </span>

                <div style={{ display: "flex", gap: "10px" }}>
                    {
                        dataUserReport.length !== 0 &&
                        <Button
                            disabled={loadingCreate}
                            size="sm"
                            color="secondary"
                            onClick={saveCreate}
                        >
                            Generar corte
                        </Button>
                    }

                    <Button
                        disabled={loadingCreate}
                        size="sm"
                        color="danger"
                        className="btn-air-light"
                        onClick={hideModalTicket}
                    >
                        Cancelar
                    </Button>
                </div>
            </div>
        </div>
    );




    //!FECH NEW
    const now = new Date();

    const fecha = now.toLocaleDateString("es-MX");
    const hora = now.toLocaleTimeString("es-MX");

    const _new = `${fecha} ${hora}`;


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const getPaymentIcon = (name = "") => {
        const method = name.toUpperCase();

        if (method.includes("EFECTIVO")) return "fa-money";

        if (method.includes("CRÉDITO") || method.includes("CREDITO"))
            return "fa-credit-card";

        if (method.includes("DÉBITO") || method.includes("DEBITO"))
            return "fa-credit-card-alt";

        if (method.includes("TRANSFER"))
            return "fa-exchange";

        if (method.includes("CHEQUE"))
            return "fa-file-text-o";

        if (method.includes("VALE"))
            return "fa-ticket";

        if (method.includes("MEMBRES"))
            return "fa-id-card";

        if (method.includes("PUNT"))
            return "fa-star";

        if (method.includes("CORTES"))
            return "fa-scissors";

        return "fa-money";
    };


    const [showMovementDialog, setShowMovementDialog] = useState(false);




    return (
        <Fragment>
            <div>
                <div className="customizer-links" style={{ width: "45px" }} >
                    <Nav className="flex-column nac-pills">
                        <NavLink onClick={showModalTicket}   >
                            <div className="settings"  >
                                <i className="fa fa-calendar-o f-18"></i>
                            </div>
                            <span>{"Generarar cortes"}</span>
                        </NavLink>
                        <NavLink onClick={() => handleViewTickets()}  >
                            <div className="settings" >
                                <i className="icofont icofont-printer f-18"></i>
                            </div>
                            <span>{"Reemprimir cortes"}</span>
                        </NavLink>
                    </Nav>
                </div>

                <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                        <Card
                            style={{
                                marginBottom: '15px',
                                background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                            }}
                        >
                            <CardBody style={{ padding: '18px 25px' }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <div style={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '15px'
                                        }}>
                                            <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/laboratory-External/cash-money.svg")} style={{ width: "60px", height: "60px" }} />
                                        </div>
                                        <div>
                                            <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                                Corte de caja
                                            </h4>
                                            <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
                                                <i className="fa fa-info-circle mr-1"></i>
                                                Detallado de los registros realizados por el usuario al dia.
                                            </small>
                                        </div>
                                    </div>

                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </div>
                {
                    // * CASH
                }
                <div style={{ scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left" }}>
                    <Row className="mt-0 mb-3">
                        {
                            // * ACCORDIAN
                        }
                        <Col sm="12" className='pt-0' >
                            <Accordion activeIndex={0}>
                                <AccordionTab
                                    header={
                                        <div className="cash-user-accordion-header">

                                            <div className="cash-user-accordion-summary">

                                                <div className="cash-user-accordion-icon">
                                                    <i className="fa fa-building-o"></i>
                                                </div>

                                                <div className="cash-user-accordion-text">
                                                    <span className="cash-user-accordion-title">
                                                        {_branchName ?? "Sin sucursal"}
                                                    </span>

                                                    <span className="cash-user-accordion-subtitle">
                                                        {_commercialLine ?? "Sin línea comercial"}
                                                    </span>
                                                </div>

                                            </div>

                                            {sumPayMethods > 0 && (
                                                <div className="cash-user-accordion-information">

                                                    <div className="cash-user-accordion-data">
                                                        <span className="cash-user-accordion-data-label">
                                                            Total de efectivo registrado
                                                        </span>

                                                        <span className="cash-user-accordion-total">
                                                            {(sumPayMethods ?? 0).toLocaleString("es-MX", {
                                                                style: "currency",
                                                                currency: "MXN"
                                                            })}
                                                        </span>
                                                    </div>

                                                    <div className="cash-user-accordion-divider"></div>

                                                    <div className="cash-user-accordion-data">
                                                        <span className="cash-user-accordion-data-label">
                                                            Responsable
                                                        </span>

                                                        <span className="cash-user-accordion-user">
                                                            <i className="fa fa-user-circle-o"></i>
                                                            {_nameUser || "Sin responsable"}
                                                        </span>
                                                    </div>

                                                </div>
                                            )}

                                        </div>
                                    }

                                >

                                    <DataTable
                                        className="data-table"
                                        value={dataUserReport}
                                        paginator
                                        rows={10}
                                        rowsPerPageOptions={[10, 20, 50]}
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "25%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                                                    No se a generada ningún ingreso.
                                                </p>
                                            </div>
                                        }
                                        header={
                                            <div className="cash-user-datatable-header">
                                                <Col sm="12" className="cash-user-table-header">
                                                    <Row className="cash-user-summary-row">

                                                        <Col sm="12" md="6" lg="2">
                                                            <div className="cash-user-summary-card">
                                                                <div className="cash-user-summary-icon cash-user-summary-icon-blue">
                                                                    <i className="pi pi-users"></i>
                                                                </div>

                                                                <div className="cash-user-summary-content">
                                                                    <span className="cash-user-summary-label">
                                                                        Total de pacientes
                                                                    </span>

                                                                    <span className="cash-user-summary-value">
                                                                        {totalPatients ?? 0}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </Col>

                                                        <Col sm="12" md="6" lg="3">
                                                            <div className="cash-user-summary-card">
                                                                <div className="cash-user-summary-icon cash-user-summary-icon-orange">
                                                                    <i className="pi pi-percentage"></i>
                                                                </div>

                                                                <div className="cash-user-summary-content">
                                                                    <span className="cash-user-summary-label">
                                                                        Total en descuentos
                                                                    </span>

                                                                    <span className="cash-user-summary-value">
                                                                        ${number_format(discountT ?? 0, 2)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </Col>

                                                        <Col sm="12" md="6" lg="2">
                                                            <div className="cash-user-summary-card">
                                                                <div className="cash-user-summary-icon cash-user-summary-icon-red">
                                                                    <i className="pi pi-times-circle"></i>
                                                                </div>

                                                                <div className="cash-user-summary-content">
                                                                    <span className="cash-user-summary-label">
                                                                        Órdenes canceladas
                                                                    </span>

                                                                    <span className="cash-user-summary-value">
                                                                        {totalCancell ?? 0}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </Col>

                                                        <Col sm="12" md="6" lg="3">
                                                            <div className="cash-user-summary-card">
                                                                <div className="cash-user-summary-icon cash-user-summary-icon-purple">
                                                                    <i className="pi pi-replay"></i>
                                                                </div>

                                                                <div className="cash-user-summary-content">
                                                                    <span className="cash-user-summary-label">
                                                                        Ingreso cancelado
                                                                    </span>

                                                                    <span className="cash-user-summary-value">
                                                                        ${number_format(dataDevolution ?? 0, 2)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </Col>

                                                        <Col sm="12" md="12" lg="2">
                                                            <div className="cash-user-search-container">
                                                                <i className="pi pi-search cash-user-search-icon"></i>

                                                                <InputText
                                                                    type="search"
                                                                    value={globalFilter ?? ""}
                                                                    onChange={(e) => setGlobalFilter(e.target.value)}
                                                                    placeholder="Buscar..."
                                                                    className="cash-user-search-input"
                                                                />

                                                                {globalFilter && (
                                                                    <button
                                                                        type="button"
                                                                        className="cash-user-search-clear"
                                                                        onClick={() => setGlobalFilter("")}
                                                                        title="Limpiar búsqueda"
                                                                    >
                                                                        <i className="pi pi-times"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                </Col>
                                            </div>
                                        }
                                        globalFilter={globalFilter}
                                    >
                                        <Column field="nim" header="Solicitud (NIM)" sortable body={customBody} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="typeClientUser" header="Paciente" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="name_branches" header="Sucursal" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column
                                            field="type"
                                            header="Tipo de ingreso"
                                            sortable
                                            body={(rowData) => {
                                                const label = rowData.type;
                                                return (

                                                    <Badge
                                                        value={label}
                                                        severity={getBadgePatient(label)}
                                                        style={{ textAlign: "center", fontSize: "10px" }}
                                                    />
                                                );
                                            }}
                                            headerStyle={headerStyle} style={centerStyle}
                                        />
                                        <Column field="cash" header="E" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="creditCard" header="T.C" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="debitCard" header="T.D" sortable headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="electronicTransfer" header="T" headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="credit" header="C" headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="amount" header="Total" sortable headerStyle={headerStyle} style={centerStyle} />

                                        <Column
                                            field="type"
                                            header="Facturado"
                                            sortable
                                            body={(rowData) => {
                                                const label = rowData.is_invoice;

                                                return (
                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <FaFilePdf style={{ marginRight: "5px", color: label === "Pendiente" ? "#dc3545" : "#28a745", fontSize: "16px" }} />
                                                    </div>
                                                );
                                            }}
                                            headerStyle={headerStyle} style={centerStyle}
                                        />
                                        <Column
                                            field="status"
                                            header="Estatus de orden"
                                            sortable
                                            body={(rowData) => {
                                                const label = rowData.status;
                                                return (
                                                    <Badge
                                                        value={label}
                                                        severity={getBadgeStatus(label)}
                                                        style={{ textAlign: "center", fontSize: "10px" }}
                                                    />
                                                );
                                            }}
                                            headerStyle={headerStyle} style={centerStyle}
                                        />

                                    </DataTable>
                                </AccordionTab>
                                {
                                    dataHistoric.length > 0 ?
                                        <AccordionTab
                                            header={
                                                <div className="cash-user-receipt-header">

                                                    <div className="cash-user-receipt-left">

                                                        <Avatar
                                                            image={mujerImage}
                                                            shape="circle"
                                                            size="large"
                                                        />

                                                        <div className="cash-user-receipt-title-group">
                                                            <span className="cash-user-receipt-title">
                                                                Recibos del corte
                                                            </span>

                                                            <span className="cash-user-receipt-subtitle">
                                                                Documentos generados del cierre de caja
                                                            </span>
                                                        </div>

                                                    </div>

                                                    <div className="cash-user-receipt-actions">

                                                        {dataHistoric.map((_find) => (
                                                            <React.Fragment key={_find.id_cash_flow}>

                                                                <div
                                                                    className="cash-user-receipt-action"
                                                                    onClick={() => printTicket(_find.id_cash_flow, 0)}
                                                                >
                                                                    <img
                                                                        src={require("../../assets/images/price/pdf.svg")}
                                                                        alt="PDF"
                                                                    />

                                                                    <span>Ticket PDF</span>
                                                                </div>

                                                                {_type_client === cedimi && (
                                                                    <>
                                                                        <div
                                                                            className="cash-user-receipt-action"
                                                                            onClick={() => downloadExcelOthers(_find.id_cash_flow, 0)}
                                                                        >
                                                                            <img
                                                                                src={require("../../assets/images/price/cash.svg")}
                                                                                alt=""
                                                                            />

                                                                            <span>Contado</span>
                                                                        </div>

                                                                        <div
                                                                            className="cash-user-receipt-action"
                                                                            onClick={() => downloadExcelCredits(_find.id_cash_flow, 0)}
                                                                        >
                                                                            <img
                                                                                src={require("../../assets/images/price/credit.svg")}
                                                                                alt=""
                                                                            />

                                                                            <span>Crédito</span>
                                                                        </div>
                                                                    </>
                                                                )}

                                                            </React.Fragment>
                                                        ))}

                                                        {loadingReport && (
                                                            <i className="fa fa-spinner fa-spin cash-user-loading-report"></i>
                                                        )}

                                                    </div>

                                                </div>
                                            }
                                        >
                                        </AccordionTab>
                                        : ""
                                }
                            </Accordion>
                            <br /> <br />
                        </Col>
                    </Row>
                </div>




            </div>
            <ModalPreviewTicket
                {
                ...{ modalPrint, toggleModalPrint, dataHistoric, printTicket, loadingPrint, downloadExcel, handleHistoric, dateEnd, dateInit, changeDate, downloadExcelCredits, downloadExcelOthers }
                }
            />


            {
                // ? DIALOG
            }
            <Dialog
                visible={visibleTicket}
                style={{ width: '70vw' }}
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">
                            <div className="Global-dialog-icon">
                                <i className="pi pi-money-bill"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Corte de Caja

                                </div>
                            </div>
                        </div>
                    </div>
                }
                className="Global-dialog Global-blue Global-medium3"
                maskClassName="custom-total-mask"
                position={showMovementDialog ? "left" : "center"}
                closable={false}
                onHide={hideModalTicket}
                footer={footerContent}>
                <Col sm="12" className='pl-0 pr-0' >
                    {
                        dataUserReport.length === 0 &&
                        <>
                            <Row>
                                <Col sm="12" md="12" lg="12" className='text-center'>
                                    <img alt='modal-preview'
                                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                        style={{ width: "40%" }} />
                                </Col>
                                <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                    <p className='txt-secondary f-w-600 f-16' >
                                        No se a generada ningún ingreso, no hay cortes pendientes.
                                    </p>
                                </Col>
                            </Row>
                        </>
                    }

                    <div className={dataUserReport.length > 0 ? "cash-authorization-content" : "d-none"}  >
                        <div className="cash-authorization-company-card">
                            <div className="cash-authorization-company-icon">
                                <i className="fa fa-building-o"></i>
                            </div>

                            <div className="cash-authorization-company-information">
                                {/* <span className="cash-authorization-section-label">
                                    REVISIÓN DE CORTE
                                </span> */}

                                <h5 className="cash-authorization-company-name">
                                    {_commercialLine ?? "Sin línea comercial"}
                                </h5>

                                <span className="cash-authorization-branch-name">
                                    SUCURSAL: &nbsp;
                                    {_branchName ?? "Sin sucursal"}
                                </span>
                            </div>

                            <div className="cash-authorization-company-logo">
                                <img
                                    src={
                                        ConfigServer.serverUrl +
                                        "/api/Configuration/Logo"
                                    }
                                    alt="Logo"
                                />
                            </div>
                        </div>

                        {
                            // ? BODY TICKET
                        }
                        <div className="cash-authorization-detail-grid">
                            <div className="cash-authorization-card">
                                <div className="cash-authorization-card-header">
                                    <div className="cash-authorization-card-header-icon cash-authorization-card-header-icon-blue2">
                                        <i className="fa fa-user"></i>
                                    </div>

                                    <div>
                                        <h6 className="cash-authorization-card-title">
                                            Usuario de caja abierta
                                        </h6>

                                        <span className="cash-authorization-card-subtitle">
                                            Fecha y hora del corte: {_new ?? "---------"}
                                        </span>
                                    </div>
                                </div>

                                <div className="cash-authorization-user">
                                    <div className="cash-authorization-user-avatar">
                                        <Media
                                            src={require("../../assets/images/loginHelenLabs/User/UserWoman.svg")}
                                            alt="Responsable del corte"
                                        />
                                    </div>

                                    <div className="cash-authorization-user-information">
                                        <div className="cash-authorization-user-detail">
                                            <span className="cash-authorization-user-name">
                                                {_nameUser ?? "Usuario no disponible"}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="cash-authorization-user-status2">
                                        <i className="fa fa-check-circle"></i>
                                        Pendiente
                                    </div>


                                </div>
                                {/* <span className="cash-authorization-user-name">
                                    <label htmlFor="">Fecha y hora de corte</label>
                                    {_new ?? "---"}

                                </span> */}


                            </div>

                            {
                                // * PAYMENT
                            }
                            <div className="cash-authorization-card">
                                <div className="cash-authorization-card-header">
                                    <div className="cash-authorization-card-header-icon cash-authorization-card-header-icon-green">
                                        <i className="fa fa-credit-card"></i>
                                    </div>

                                    <div>
                                        <h6 className="cash-authorization-card-title">
                                            Métodos de pago
                                        </h6>

                                        <span className="cash-authorization-card-subtitle">
                                            Importes registrados en el corte
                                        </span>
                                    </div>

                                    <span className="cash-authorization-level cash-authorization-level-green">
                                        {typeAmoun?.length ?? 0} {typeAmoun?.length === 1 ? "método" : "métodos"}
                                    </span>
                                </div>

                                <div className="cash-authorization-payment-list">
                                    {typeAmoun?.length > 0 ? (
                                        [...typeAmoun].sort().map((_find, index) => (
                                            <div
                                                className="cash-authorization-payment-item"
                                                key={`${_find}-${index}`}
                                            >
                                                <div className="cash-authorization-payment-information">
                                                    <span className="cash-authorization-payment-icon">
                                                        <i className={`fa ${getPaymentIcon(_find)}`}></i>
                                                    </span>

                                                    <span className="cash-authorization-payment-name">
                                                        {_find}
                                                    </span>
                                                </div>

                                                <span className="cash-authorization-payment-amount">
                                                    {formatter.format(Number(wilso?.[_find]?.Amount ?? 0))}
                                                </span>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="cash-authorization-empty">
                                            <i className="fa fa-info-circle"></i>
                                            No existen métodos de pago registrados.
                                        </div>
                                    )}
                                </div>


                                <div className="cash-authorization-total">
                                    <div className="cash-authorization-total-information">
                                        <span className="cash-authorization-total-label">
                                            <strong>{typeAmoun?.length ?? 0}</strong>{" "}
                                            {typeAmoun?.length === 1
                                                ? "método de pago registrado"
                                                : "métodos de pago registrados"}
                                        </span>
                                        <span className="cash-authorization-total-description">
                                            Suma de todos los métodos de pago
                                        </span>
                                    </div>

                                    <span className="cash-authorization-total-amount">
                                        {formatter.format(
                                            (typeAmoun ?? []).reduce(
                                                (total, method) => total + Number(wilso?.[method]?.Amount ?? 0),
                                                0
                                            )
                                        )}
                                    </span>
                                </div>
                            </div>
                        </div>
                        {
                            // ?  AMOUNT TO BE REPORTED
                        }
                        <div className="cash-authorization-authorization-card">
                            <div className="cash-authorization-authorization-header">
                                <div className="cash-authorization-authorization-icon">
                                    <i className="fa fa-check-square-o"></i>
                                </div>

                                <div>
                                    <h6 className="cash-authorization-authorization-title">
                                        Monto a reportar en caja
                                    </h6>

                                    <span className="cash-authorization-authorization-subtitle">
                                        Datos de los moviemientos registrados
                                    </span>
                                </div>
                            </div>

                            <div className="cash-authorization-authorization-grid">

                                <div className="cash-authorization-information-item">
                                    <div className="cash-authorization-information-number">
                                        1
                                    </div>

                                    <div className="cash-authorization-information-content">
                                        <span className="cash-authorization-information-label">
                                            Monto en efectivo a reportar
                                        </span>


                                        <span className="cash-authorization-information-label">
                                            <input disabled={_type_client === "https://insan.helen-sw.com2" ? true : false} type="number" className='inputCash f-12' placeholder={_type_client === "https://insan.helen-sw.com2" ? "" : 'Ingrese la cantidad'} value={_type_client === "https://insan.helen-sw.com2" ? _total ?? 0 : capture_amount} name="capture_amount" onChange={handleInputChangeCash} />
                                        </span>
                                    </div>
                                </div>
                                <div className="cash-authorization-information-item pr-0">
                                    <div className="cash-authorization-information-number cash-authorization-information-number-green">
                                        2
                                    </div>

                                    <div className="cash-authorization-information-content">
                                        <span className="cash-authorization-information-label">
                                            Comentario adjunto al recibo de corte
                                        </span>
                                        <textarea
                                            className='form-control form-control-sm input-air-primary'
                                            name="comments"
                                            rows="3"
                                            value={comments}
                                            onChange={handleInputChangeCash}
                                            style={{ fontSize: "12px" }}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            // ? VIEW    TICKET
                        }
                        <div className="cash-authorization-alert">
                            <div className="cash-authorization-alert-icon">
                                <i className="fa fa-exclamation-triangle"></i>
                            </div>

                            <div className="cash-authorization-alert-content">
                                <span className="cash-authorization-alert-title">
                                    Visualización del pdf
                                </span>

                                <span className="cash-authorization-alert-description">
                                    Verifica la información sea la correcta
                                    antes de generar el corte.
                                </span>
                            </div>

                            <button
                                type="button"
                                className="cash-authorization-detail-button"
                                onClick={() => setShowMovementDialog(true)}
                            >
                                <i className="fa fa-eye"></i>
                                Visualizar movimientos
                            </button>
                        </div>


                    </div>
                </Col>
            </Dialog>


            {
                // ? TICKET
            }
            <Dialog
                visible={showMovementDialog}
                onHide={() => setShowMovementDialog(false)}
                modal
                draggable={false}
                resizable={false}
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">

                            <div className="Global-dialog-icon">
                                <i className="pi pi-file-pdf"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Ticket
                                </div>
                            </div>

                        </div>
                    </div>
                }
                className={`Global-dialog Global-dialog Global-blue Global-small-v3 `}
                position="right"


            >
                <div className="cash-authorization-detail-container">
                    <Col sm="12"   >
                        <div>
                            <Col sm="12" style={{ textAlign: "center" }} >
                                <img className="b-r-10" src={ConfigServer.serverUrl + "/api/Configuration/Logo"} style={{ width: "35%" }} alt="logo" />
                            </Col>
                            <Row>
                                <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                    <label className='f-14 f-w-600'>{_commercialLine} </label> <br />
                                    <label style={{ fontSize: "11px" }} className=' f-w-600'>{_branchName} </label> <br />
                                    <div className='preview-cash-div' ></div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12" >
                                    <Col sm="12" style={{ textAlign: "center" }}>
                                        <label style={{ fontSize: "10px" }} >DETALLE</label>
                                    </Col>
                                    <div className="table-responsive">
                                        <Table className='table-sm table-stripped' >
                                            <thead>
                                                <tr style={{ backgroundColor: "#46AFE5" }}>
                                                    <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle</td>
                                                </tr>
                                                <tr>
                                                    <th style={{ color: "#000", textAlign: "center" }} > <label className='f-w-600 f-12'>Fecha de inicio</label></th>
                                                    <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>Fecha de corte</label></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className='text-center f-w-500' style={{ fontSize: "11px" }}>
                                                    <td>{_new ?? "---------"}</td>
                                                    <td>{_new ?? "---------"}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>

                                    <div className="table-responsive">
                                        <Table className='table-sm table-stripped' >
                                            <thead>
                                                <tr style={{ backgroundColor: "#46AFE5" }}>
                                                    <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle</td>
                                                </tr>
                                                <tr>
                                                    <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>MÉTODO DE PAGO</label></th>
                                                    <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>TOTAL</label></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    typeAmoun?.length > 0 && typeAmoun?.sort() && typeAmoun?.map((_find, index) => {
                                                        return <tr key={_find} className='text-center f-w-500' style={{ fontSize: "11px" }}>
                                                            <td>{_find ?? "----"}</td>
                                                            <td><label className='f-12 f-w-600 '>{formatter.format(wilso[_find].Amount !== undefined && wilso[_find].Amount)}</label></td>
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                        </Table>
                                    </div>

                                    <div className="table-responsive">
                                        <Table className='table-sm table-stripped' >
                                            <thead>
                                                <tr style={{ backgroundColor: "#46AFE5" }}>
                                                    <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle de movimientos</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className='f-12'> <b className='f-12'>Descuentos</b></td>
                                                    <td className="text-center"><b className='f-12'>$ {number_format(discountT ?? 0, 2)}</b></td>
                                                </tr>
                                                <tr>
                                                    <td className='f-12'> <b className='f-12'>Cancelaciones</b></td>
                                                    <td className="text-center "><b className='f-12'>$ {number_format(cancell ?? 0, 2)}</b></td>
                                                </tr>
                                                <tr>
                                                    <td className='f-12'> <b className='f-12'>Total</b></td>
                                                    <td className="text-center "><b className='f-12'>$ {number_format(sumPayMethods ?? 0, 2)}</b></td>
                                                </tr>
                                                <tr>
                                                    <td className='f-12'> <b className='f-12'>Efectivo registrado</b></td>
                                                    <td className="text-center "><b className='f-12'>$ {number_format(formCash.capture_amount ?? 0, 2)}</b></td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <br />
                                        <b htmlFor="">{formCash.comments ?? "--------"}</b>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }}>
                                    <div className='preview-cash-div' ></div>
                                    <label style={{ fontSize: "11px" }} className=' f-w-600'>{_nameUser} </label> <br />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </div>
            </Dialog>

            {showAlert && (
                <CustomAlertDialogGlobal
                    visible={showAlert}
                    title="Corte de caja "
                    message={`No se puede realizar el corte si no se agrega un monto, o en su defecto colocar 0 <strong>  </strong> .`}
                    buttonText="Aceptar"
                    onAccept={cancelTabChange}
                    visibleOnCancel={false}
                />
            )}
            {showAlert2 && (
                <CustomAlertDialogGlobal
                    visible={showAlert2}
                    title="Corte de caja "
                    message={`El monto ingresado supera el 10% permitido.`}
                    buttonText="Aceptar"
                    onAccept={cancelTabChange2}
                    visibleOnCancel={false}
                />
            )}


            <ToastAletGlobal
                visible={showToast}
                type={toastType}
                title={toastTitle}
                message={toastMessage}
                onClose={closeToastAlert}
            />
        </Fragment >
    )
}
